export default __webpack_public_path__ + "static/media/skink.f529fde4.png";